import React from 'react';
import {
  HtmlTable,
  HtmlTableProps,
} from '../../../../../../../CommonComponents/OPL/HtmlTable/HtmlTable';
import { Text } from '../../../../../../../CommonComponents/OPL/Text/Text';

export const AssetsTable: React.FC<HtmlTableProps> = ({ children, ...rest }) => {
  return (
    <HtmlTable
      variant="embedded"
      columnSpacing="small"
      fixedHead
      maxHeight="56vh"
      mb="32"
      {...rest}
    >
      <table
        css={`
          table-layout: fixed;
        `}
      >
        <thead>
          <tr>
            <th
              css={`
                width: 60%;
              `}
            >
              <Text variant="smallCaps" textAlign="left">
                Category
              </Text>
            </th>

            <th>
              <Text variant="smallCaps" textAlign="right">
                Allocation
              </Text>
            </th>

            <th>
              <Text variant="smallCaps" textAlign="right">
                Value
              </Text>
            </th>
          </tr>
        </thead>

        <tbody>{children}</tbody>
      </table>
    </HtmlTable>
  );
};
